import {
  SET_STATION,
  SENDING_PRESENTATION_STATION_REQUEST,
  FETCH_PRESENTATION_STATION_SUCCESS,
  FETCH_PRESENTATION_STATION_FAILURE,
  SENDING_DEVICE_STATUS_REQUEST,
  DEVICE_STATUS_UPDATED,
  SENDING_RECENT_EVENT_REQUEST,
  FECTH_RECENT_EVENT_SUCCESS,
  FECTH_RECENT_EVENT_FAILURE,
  NEW_EVENTS_UPDATED,
  MQTT_NEW_EVENT_RECEIVED,
  SENDING_DEVICE_COMMAND_REQUEST,
  SENDING_REBOOT_REQUEST,
  SENDING_SYNC_REQUEST
} from '../actions/constants'

const initialState = {
  devices: [],
  rooms: [],
  cameras: [],
  scripts: [],
  events: [],
  fetchingDevices: false,
  receivingNewEvents: false,
  fetchingRecentEvent: false,
  sendingDeviceCommand: false,
  error: ''
}

const device = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATION:
      return {
        ...state,
        devices: [],
        rooms: [],
        cameras: [],
        scripts: [],
        events: [],
        fetchingDevices: false,
        receivingNewEvents: false,
        fetchingRecentEvent: false,
        sendingDeviceCommand: false,
        error: ''
      }
    case SENDING_PRESENTATION_STATION_REQUEST:
      return {
        ...state,
        fetchingDevices: action.sending
      }
    case FETCH_PRESENTATION_STATION_SUCCESS:
      return {
        ...state,
        devices: action.devices,
        rooms: action.rooms,
        cameras: action.cameras,
        scripts: action.scripts,
        error: ''
      }
    case FETCH_PRESENTATION_STATION_FAILURE:
      return {
        ...state,
        devices: [],
        rooms: [],
        scripts: [],
        error: action.error
      }
    case DEVICE_STATUS_UPDATED:
      return {
        ...state,
        devices: action.devices
      }
    case SENDING_DEVICE_STATUS_REQUEST:
      return {
        ...state,
        fetchingDevices: action.sending
      }
    case SENDING_RECENT_EVENT_REQUEST:
      return {
        ...state,
        fetchingRecentEvent: action.sending
      }
    case FECTH_RECENT_EVENT_SUCCESS:
      return {
        ...state,
        events: action.events
      }
    case FECTH_RECENT_EVENT_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case MQTT_NEW_EVENT_RECEIVED:
      return {
        ...state,
        receivingNewEvents: true
      }
    case NEW_EVENTS_UPDATED:
      return {
        ...state,
        receivingNewEvents: false,
        events: action.events
      }
    case SENDING_DEVICE_COMMAND_REQUEST:
    case SENDING_REBOOT_REQUEST:
    case SENDING_SYNC_REQUEST:
      return {
        ...state,
        sendingDeviceCommand: action.sending
      }
    default:
      return state
  }
}

export default device



// WEBPACK FOOTER //
// ./src/reducers/device.js